import { toast } from "react-toastify";

export const snackbarToast =(content, type) => {
    toast(content, {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        autoClose: 4000,
        type: type
    })
}